
import React from 'react';
import ReactDOM from 'react-dom';

import { Provider } from 'react-redux';
import { store } from './app/store/store';

//import './bridge/init';
import './app/router';

import './css/style.css';

import AppContainer from './components/appMain/App';

ReactDOM.render(
	(
		<Provider store={store}>
			<AppContainer />
		</Provider>
	),
	document.getElementById("root")
);

// Check
// github.com/nfl/react-helmet

if (process.env.NODE_ENV === "development") {
	import('./app/devSettings').then(module => { });
	import("./eruda").then(({ default: eruda }) => { });	//runtime download
}
